import { units } from '@ui/css';
import { combineTokens } from '@utils/css';
import { makeSizeTokens } from '@utils/react/selectors';

const actionsSize = makeSizeTokens("--actions", units.px(0));
const headerSize = makeSizeTokens("--header", {
  height: units.px(42),
  width: "100%"
});
const tokens = combineTokens("--opgavekomplekset", {
  buttonCount: 4,
  buttonWidth: units.px(50),
  paddingInline: 0,
  paddingBlockStart: 0,
  paddingBlockEnd: 0
});

export { actionsSize, headerSize, tokens };
//# sourceMappingURL=_component.tokens.js.map
